import { render, staticRenderFns } from "./decoration-policy-holder-form.vue?vue&type=template&id=128a6972&scoped=true&"
import script from "./decoration-policy-holder-form.vue?vue&type=script&lang=js&"
export * from "./decoration-policy-holder-form.vue?vue&type=script&lang=js&"
import style0 from "./decoration-policy-holder-form.vue?vue&type=style&index=0&id=128a6972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128a6972",
  null
  
)

export default component.exports